import { Controller } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import { Checkbox } from '@gto/ui/checkbox'
import { Typography } from '@gto/ui/typography'

import { fieldErrorText } from './form'
import type { PayoutMethodForm } from './use-payout-method-form'

type UsdOnlyConfirmationFieldProps = {
  form: PayoutMethodForm
  disabled?: boolean
}

/** The partner's attestation that the account receives USD — rendered only on
 *  the partner's own payout form, which validates it as required. */
export const UsdOnlyConfirmationField = ({
  form,
  disabled = false,
}: UsdOnlyConfirmationFieldProps) => {
  const { formatMessage } = useIntl()

  return (
    <Controller
      control={form.control}
      name="usdOnlyConfirmed"
      render={({ field, fieldState }) => {
        const error = fieldErrorText(formatMessage, fieldState.error, 'payout.')

        return (
          <div className="flex flex-col gap-1">
            <Typography
              color="text.secondary"
              variant="body2"
            >
              <FormattedMessage id="payout.usdOnly.explanation" />
            </Typography>
            <Checkbox
              checked={field.value}
              data-tst="payout-usd-only-confirmation"
              disabled={disabled}
              inputRef={field.ref}
              label={<FormattedMessage id="payout.usdOnly.label" />}
              name={field.name}
              onCheckedChange={(checked) => field.onChange(checked)}
            />
            {error !== undefined && (
              <Typography
                color="error"
                role="alert"
                variant="caption"
              >
                {error}
              </Typography>
            )}
          </div>
        )
      }}
    />
  )
}
